(function () {
  var configNode = document.getElementById('AtorHomeFavoritesConfig');
  if (!configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent);
  } catch (error) {
    return;
  }

  var storageKey = config.storageKey;
  var page = document.querySelector('[data-favorites-page]');

  function readFavorites() {
    try {
      var value = JSON.parse(window.localStorage.getItem(storageKey) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter(function (item) {
        return item && typeof item.id === 'string' && item.id.length > 0;
      });
    } catch (error) {
      return [];
    }
  }

  function writeFavorites(items) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(items));
    } catch (error) {
      return;
    }
  }

  function updateHeader(items) {
    document.querySelectorAll('[data-favorites-count]').forEach(function (badge) {
      badge.textContent = String(items.length);
      badge.hidden = items.length === 0;
    });
    document.querySelectorAll('[data-favorites-link]').forEach(function (link) {
      link.setAttribute(
        'aria-label',
        items.length ? config.headerCountLabel.replace('{count}', String(items.length)) : config.headerLabel
      );
    });
  }

  function safeProductUrl(value) {
    return typeof value === 'string' && value.charAt(0) === '/' && value.slice(0, 2) !== '//'
      ? value
      : '/collections/all';
  }

  function createFavoriteCard(item) {
    var listItem = document.createElement('li');
    listItem.className = 'favorites-card';

    var imageLink = document.createElement('a');
    imageLink.className = 'favorites-card__image-link';
    imageLink.href = safeProductUrl(item.url);
    imageLink.setAttribute('aria-label', item.title || '');

    if (typeof item.image === 'string' && (item.image.indexOf('https://') === 0 || item.image.charAt(0) === '/')) {
      var image = document.createElement('img');
      image.className = 'favorites-card__image';
      image.src = item.image;
      image.alt = item.title || '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    }

    var details = document.createElement('div');
    details.className = 'favorites-card__details';

    var text = document.createElement('div');
    var title = document.createElement('a');
    title.className = 'favorites-card__title';
    title.href = safeProductUrl(item.url);
    title.textContent = item.title || '';
    text.appendChild(title);

    if (item.price) {
      var price = document.createElement('p');
      price.className = 'favorites-card__price';
      price.textContent = item.price;
      text.appendChild(price);
    }

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'favorites-card__remove';
    remove.setAttribute('data-favorites-remove', item.id);
    remove.setAttribute('aria-label', config.removeItemLabel.replace('{title}', item.title || ''));
    remove.textContent = config.removeButton;

    details.appendChild(text);
    details.appendChild(remove);
    listItem.appendChild(imageLink);
    listItem.appendChild(details);
    return listItem;
  }

  function renderPage(items) {
    if (!page) return;
    var list = page.querySelector('[data-favorites-items]');
    var empty = page.querySelector('[data-favorites-empty]');
    var emptyActions = page.querySelector('[data-favorites-empty-actions]');
    list.replaceChildren();
    items.forEach(function (item) {
      list.appendChild(createFavoriteCard(item));
    });
    list.hidden = items.length === 0;
    empty.hidden = items.length > 0;
    emptyActions.hidden = items.length > 0;
  }

  function sync() {
    var items = readFavorites();
    var itemIds = new Set(items.map(function (item) { return item.id; }));
    document.querySelectorAll('[data-favorites-toggle]').forEach(function (button) {
      var saved = itemIds.has(button.dataset.favoritesProductId);
      var label = saved ? button.dataset.labelRemove : button.dataset.labelAdd;
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      var hiddenLabel = button.querySelector('.visually-hidden');
      if (hiddenLabel) hiddenLabel.textContent = label;
    });
    updateHeader(items);
    renderPage(items);
  }

  function setFavorite(button, shouldSave) {
    var id = button.dataset.favoritesProductId;
    var items = readFavorites().filter(function (item) { return item.id !== id; });
    if (shouldSave) {
      items.unshift({
        id: id,
        title: button.dataset.favoritesProductTitle || '',
        url: safeProductUrl(button.dataset.favoritesProductUrl),
        image: button.dataset.favoritesProductImage || '',
        price: button.dataset.favoritesProductPrice || ''
      });
    }
    writeFavorites(items);
    sync();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var remove = target.closest('[data-favorites-remove]');
    if (remove) {
      event.preventDefault();
      event.stopPropagation();
      var removeId = remove.getAttribute('data-favorites-remove');
      writeFavorites(readFavorites().filter(function (item) { return item.id !== removeId; }));
      sync();
      return;
    }

    var button = target.closest('[data-favorites-toggle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    var saved = readFavorites().some(function (item) {
      return item.id === button.dataset.favoritesProductId;
    });
    setFavorite(button, !saved);
  }, true);

  window.addEventListener('storage', function (event) {
    if (event.key === storageKey) sync();
  });

  sync();
})();
